define(['exports', 'babel-runtime/regenerator', 'babel-runtime/helpers/asyncToGenerator', 'babel-runtime/helpers/extends', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/createClass'], function (exports, _regenerator, _asyncToGenerator2, _extends2, _classCallCheck2, _createClass2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.setLanguage = undefined;
  exports.syncWithStore = syncWithStore;
  exports.langReducer = langReducer;

  var _regenerator2 = _interopRequireDefault(_regenerator);

  var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

  var _extends3 = _interopRequireDefault(_extends2);

  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

  var _createClass3 = _interopRequireDefault(_createClass2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var instances = [];
  var language = 'ru';
  var store = void 0;

  var MultiLanguage = function () {
    function MultiLanguage(props) {
      (0, _classCallCheck3.default)(this, MultiLanguage);

      this.props = props;

      this.propsToObj();
      instances.push(this);
    }

    (0, _createClass3.default)(MultiLanguage, [{
      key: 'propsToObj',
      value: function propsToObj() {
        for (var key in this.props[language]) {
          this[key] = this.props[language][key];
        }
      }
    }]);
    return MultiLanguage;
  }();

  exports.default = MultiLanguage;
  function syncWithStore(link) {
    store = link;

    store.subscribe(function () {
      var state = store.getState();

      if (state.lang.code !== language) {
        setLanguage(state.lang.code);
      }
    });
  }

  function langReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { code: language };
    var action = arguments[1];

    switch (action.type) {
      case 'SET_REDUX_LANGUAGE':
        return (0, _extends3.default)({}, state, { code: action.code });
      default:
        return state;
    }
  }

  var setLanguage = exports.setLanguage = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(code) {
      var i;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (store) {
                _context.next = 2;
                break;
              }

              throw new Error('Use `syncWithStore` first');

            case 2:

              language = code;
              for (i in instances) {
                instances[i].propsToObj();
              }

              store.dispatch({
                type: 'SET_REDUX_LANGUAGE',
                code: code
              });

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function setLanguage(_x2) {
      return _ref.apply(this, arguments);
    };
  }();
});
